import React from 'react';
import {
  setCurrentPage,
  setIsEditingPage,
  setPageInputValue,
  setSelectedFile,
  setTemplateName,
} from '@/redux/CustomContracts/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import ButtonComponent from '@/components/common-components/ButtonComponent/ButtonComponent';
import CustomTooltip from '@/components/common-components/CustomTooltip/CustomTooltip';
import ArrowLeft from '@/components/Icons/icons/ArrowLeft';

interface TopbarProps {
  pageInputRef: React.RefObject<HTMLInputElement>;
  onSave: () => Promise<void>;
  isSubmitting: boolean;
  missingRequiredFields: string[];
  isEditMode: boolean;
  onBackClick: () => void;
}

const Topbar = ({
  pageInputRef,
  onSave,
  isSubmitting,
  missingRequiredFields,
  isEditMode,
  onBackClick,
}: TopbarProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { currentPage, isEditingPage, pageInputValue, numPages } = useSelector((state: any) => state.customContract);

  const handlePageInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setPageInputValue(e.target.value));
  };
  const handlePageInputBlur = () => {
    const newPage = parseInt(pageInputValue, 10);
    if (!isNaN(newPage) && newPage >= 1 && newPage <= numPages) {
      dispatch(setCurrentPage(newPage));
    } else {
      dispatch(setPageInputValue(currentPage.toString()));
    }
    dispatch(setIsEditingPage(false));
  };
  const handlePageInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handlePageInputBlur();
    } else if (e.key === 'Escape') {
      dispatch(setPageInputValue(currentPage.toString()));
      dispatch(setIsEditingPage(false));
    }
  };

  const handleSave = async () => {
    try {
      await onSave();
    } catch (error) {
      console.error('Error saving template:', error);
    }
  };

  return (
    <div className="flex-between items-center custom-contract-topbar">
      <div className="flex flex-start gap-1">
        <div className="cursor-pointer" onClick={onBackClick}>
          <ArrowLeft color="#667085" />
        </div>
        <h3 className="custom-contract-topbar-title">
          {isEditMode ? 'Edit Contract Template' : 'Create Contract Template'}
        </h3>
      </div>
      <div className="page-navigation">
        <div className="page-counter">
          {isEditingPage ? (
            <input
              ref={pageInputRef}
              type="text"
              value={pageInputValue}
              onChange={handlePageInputChange}
              onBlur={handlePageInputBlur}
              onKeyDown={handlePageInputKeyDown}
              className="page-input"
            />
          ) : (
            <span onClick={() => dispatch(setIsEditingPage(true))} className="page-display">
              {currentPage}
            </span>
          )}
          <span className="page-separator"> / </span>
          <span className="text-subdued">{numPages}</span>
        </div>
      </div>
      <div className="relative">
        <CustomTooltip
          title={missingRequiredFields.length > 0 ? `Add Signature fields to save template` : ''}
          show={missingRequiredFields.length > 0}
          placement="bottom">
          <div>
            <ButtonComponent
              style={{ width: '306px', height: '44px' }}
              onClick={handleSave}
              disabled={missingRequiredFields.length > 0 || isSubmitting}>
              {isSubmitting ? 'Saving...' : isEditMode ? 'Update Template' : 'Save Template'}
            </ButtonComponent>
          </div>
        </CustomTooltip>
      </div>
    </div>
  );
};

export default Topbar;
